module.exports = __webpack_public_path__ + "assets/img/Ic-QQ.dbe879b4.svg";